import "babel-polyfill";
import React, { Component } from "react";
import Main from "./Main";
import { createLogger } from "redux-logger";
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import ReduxThunk from "redux-thunk";
import { persistStore, persistCombineReducers } from "redux-persist";
import storage from "redux-persist/es/storage";
import { PersistGate } from "redux-persist/es/integration/react";
import { BrowserRouter as Router } from "react-router-dom";

import reducers_ from "./containers/combinedReducer";

const logger = createLogger({
  collapsed:true
});

const config = {
  key: "_channel_illumine",
  storage
};
const reducers = persistCombineReducers(config, reducers_);

class App extends Component {
  render() {
    const store = createStore(reducers, {}, applyMiddleware(ReduxThunk, logger));
    let persistor = persistStore(store);
    return (
      <Provider store={store}>
        <PersistGate
          loading={
            <div>
              <p>Loading</p>
            </div>
          }
          onBeforeLift={() => {}}
          persistor={persistor}
        >
        <Router>
          <Main />
        </Router>
        </PersistGate>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js